import { callApi } from '@local_modules/generic/fetch.js'

export async function loadGroupAllContacts (appAccountId) {
  const apiUrl = '/api/xero-accounting/contacts/account/:appAccountId'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  console.log(data)

  return data
}
